import { render } from "./Boolean.vue?vue&type=template&id=7480a9ad"
import script from "./Boolean.vue?vue&type=script&lang=js"
export * from "./Boolean.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__